import {Component, OnInit, ViewChild} from '@angular/core';
import {Permission} from "../../../../model/profile";
import {ProfileFilters} from "../../../../model/filters/profile-filters";
import {AuthGuard} from "../../../../common/auth-guard.service";
import {PermissionService} from "../../../../services/permission.service";
import {PermissionFilters} from "../../../../model/filters/permission-filters";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-permission-list',
  templateUrl: './permission-list.component.html',
  styleUrls: ['./permission-list.component.scss']
})
export class PermissionListComponent implements OnInit {

  @ViewChild("table")
  public table: any;

  public permissions: Permission[];
  public totalPermissions: number;
  public loadingPermissions: boolean;

  public rows: number = 10;
  public first: number = 0;

  public filtersVisible: boolean;
  public currentFilters: PermissionFilters;


  constructor(private route: ActivatedRoute,
              private permissionService: PermissionService,
              public guard: AuthGuard) {
    this.currentFilters = new PermissionFilters();
  }

  ngOnInit(): void {
    this.permissions = new Array(this.rows);
    this.loadPermissions();
  }

  resetFilters(): void {
    this.currentFilters = new ProfileFilters();
    this.totalPermissions = this.permissions.length;
  }

  applyFilters(): void {
    this.first = 0;
    this.table.filter(this.currentFilters.name?.trim(), 'name', 'contains');
    this.filtersVisible = false;
  }

  onFilter(event: any): void {
    this.totalPermissions = event.filteredValue.length;
  }

  private loadPermissions(): void {
    this.loadingPermissions = true;
    this.permissions = new Array(this.rows);
    this.permissionService.getPermissions()
      .subscribe(response => {
        this.permissions = response.permissions;
        this.totalPermissions = response.permissions.length;
        this.loadingPermissions = false;
      });
  }

}

